// Minimal History-API router.

class Router {
  path = $state(location.pathname);
  query = $state(new URLSearchParams(location.search));

  constructor() {
    window.addEventListener('popstate', () => {
      this.path = location.pathname;
      this.query = new URLSearchParams(location.search);
    });
  }
}

export const router = new Router();
